import { login, logout, getInfo } from "@/api/user"
import { getToken, setToken, removeToken } from "@/utils/auth"
import { resetRouter } from "@/router"
import Cookies from "js-cookie"

const getDefaultState = () => {
  return {
    token: getToken(),
    name: "",
    avatar: "",
    userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : "",
    roleInfo: Cookies.get("roleInfo") ? JSON.parse(Cookies.get("roleInfo")) : ""
  }
}

const state = getDefaultState()

const mutations = {
  //重置状态
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  //设置token
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  //设置用户名
  SET_NAME: (state, name) => {
    state.name = name
  },
  //设置用户头像
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  //设置用户信息
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  //设置角色信息
  SET_ROLEINFO: (state, roleInfo) => {
    state.roleInfo = roleInfo
  }
}

const actions = {
  // user login
  login({ commit }, res) {
    const { account, password } = res
    return new Promise((resolve, reject) => {
      login({ Account: account.trim(), Pwd: password })
        .then((data) => {
          commit("SET_USERINFO", data.User)
          Cookies.set("userInfo", JSON.stringify(data.User))

          commit("SET_ROLEINFO", data.Role)
          Cookies.set("roleInfo", JSON.stringify(data.Role))

          commit("SET_TOKEN", data.token)
          setToken(data.token)

          var rolemoudule = new Array()
          data.rolemoudule.forEach((item) => {
            if (item.permission_json && item.permission_json != "null") {
              rolemoudule.push({ s_id: item.second_id, p_json: item.permission_json })
            } else {
              rolemoudule.push({ s_id: item.second_id })
            }
          })
          localStorage.setItem("rolemoudule", JSON.stringify(rolemoudule))
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  base64Encode(str) {
    // 先用 encodeURIComponent 把 UTF-8 编码，再用 btoa
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode("0x" + p1)))
  },
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then((response) => {
          const { data } = response

          if (!data) {
            return reject("Verification failed, please Login again.")
          }

          const { name, avatar } = data

          commit("SET_NAME", name)
          commit("SET_AVATAR", avatar)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // user logout
  logout({ commit }) {
    // return new Promise((resolve, reject) => {
    //   logout(state.token).then(() => {
    removeToken() // must remove  token  first
    Cookies.remove("userInfo")
    resetRouter()
    commit("RESET_STATE")
    // resolve()
    // }).catch(error => {
    //   reject(error)
    // })
    // })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken() // must remove  token  first
      commit("RESET_STATE")
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
